import React from "react";
import {
  MapPin,
  Phone,
  Mail,
  MessageCircle,
  Instagram,
  Facebook,
  Youtube,
} from "lucide-react";
import { trackCAPIContact } from "../utils/metaConversionsAPI";

export const FooterCRO = () => {
  return (
    <footer className="bg-gray-900 text-white pb-20 md:pb-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <div className="flex items-center mb-4">
              <img
                src="/images/TFBC-WHITE-LOGO.png"
                alt="The Free Birds Collective"
                className="h-16 sm:h-20 w-auto object-contain"
              />
            </div>
            <p className="text-gray-400 leading-relaxed mb-6 max-w-md">
              Transforming aspiring actors into professionals for over 50 years.
              Advanced, practical training in film and theatre acting,
              personally conducted by Padma Shri Awardee Barry John.
            </p>
            {/* Social Links */}
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/thefreebirdscollective"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-purple-600 rounded-full flex items-center justify-center transition-all duration-300"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/barryjohnsfreebirds/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-purple-600 rounded-full flex items-center justify-center transition-all duration-300"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://www.youtube.com/@Thefreebirdscollective"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-purple-600 rounded-full flex items-center justify-center transition-all duration-300"
                aria-label="YouTube"
              >
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Programmes Column */}
          <div>
            <h4 className="text-lg font-bold mb-4">Programmes</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="#"
                  className="text-gray-400 hover:text-purple-400 transition-colors duration-300"
                >
                  Diploma (Full-Time)
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 hover:text-purple-400 transition-colors duration-300"
                >
                  Weekend (Part-Time)
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 hover:text-purple-400 transition-colors duration-300"
                >
                  About Barry John
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-400 hover:text-purple-400 transition-colors duration-300"
                >
                  Alumni Network
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-gray-400">
                <MapPin className="w-5 h-5 text-purple-400 flex-shrink-0" />
                <span>Mumbai, India</span>
              </li>
              <li className="flex items-center gap-3 text-gray-400">
                <Phone className="w-5 h-5 text-purple-400 flex-shrink-0" />
                <a
                  href="tel:+918591218023"
                  className="hover:text-purple-400 transition-colors"
                  onClick={() => {
                    // Generate unique event ID for deduplication
                    const contactEventId = `contact_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
                    
                    // Track Meta Pixel Contact event (browser-side)
                    if (typeof window !== "undefined" && typeof window.fbq === "function") {
                      window.fbq("track", "Contact", {
                        content_name: "Phone",
                        content_category: "Footer Contact",
                      }, { eventID: contactEventId });
                    }
                    // Track Meta Conversions API Contact event (server-side) with same event ID
                    trackCAPIContact("Phone", contactEventId);
                  }}
                >
                  +91 85912 18023
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-400">
                <Mail className="w-5 h-5 text-purple-400 flex-shrink-0" />
                <a
                  href="mailto:thefreebirdscollectiveindia@gmail.com"
                  className="hover:text-purple-400 transition-colors"
                  onClick={() => {
                    // Generate unique event ID for deduplication
                    const contactEventId = `contact_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
                    
                    // Track Meta Pixel Contact event (browser-side)
                    if (typeof window !== "undefined" && typeof window.fbq === "function") {
                      window.fbq("track", "Contact", {
                        content_name: "Email",
                        content_category: "Footer Contact",
                      }, { eventID: contactEventId });
                    }
                    // Track Meta Conversions API Contact event (server-side) with same event ID
                    trackCAPIContact("Email", contactEventId);
                  }}
                >
                  thefreebirdscollectiveindia@gmail.com
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/918591218023"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 px-4 py-2 rounded-lg transition-all duration-300 mt-2"
                  onClick={() => {
                    // Generate unique event ID for deduplication
                    const contactEventId = `contact_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
                    
                    // Track Meta Pixel Contact event (browser-side)
                    if (typeof window !== "undefined" && typeof window.fbq === "function") {
                      window.fbq("track", "Contact", {
                        content_name: "WhatsApp",
                        content_category: "Footer Contact",
                      }, { eventID: contactEventId });
                    }
                    // Track Meta Conversions API Contact event (server-side) with same event ID
                    trackCAPIContact("WhatsApp", contactEventId);
                  }}
                >
                  <MessageCircle className="w-4 h-4" />
                  <span className="text-sm font-semibold">WhatsApp Us</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © 2025 The Free Birds Collective. All rights reserved.
            </p>
            <p className="text-gray-500 text-sm">
              Built with ❤️ by{" "}
              <a
                href="https://www.talecrafters.in?ref=tfbc"
                target="_blank"
                rel="noopener noreferrer"
                className="text-purple-400 hover:text-purple-300 transition-colors"
              >
                TaleCrafters
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
